import './FAQ.css';
export default {
    "view__wrapper": "FAQ_view__wrapper__jevhi",
    "question": "FAQ_question__jevhi",
    "answer": "FAQ_answer__jevhi"
};
